/**
 * @generated SignedSource<<de4f65f79825899a12a2b57e98911ab1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordVideoButton_Query$variables = Record<PropertyKey, never>;
export type RecordVideoButton_Query$data = {
  readonly configuration: {
    readonly videoMinDuration: number | null | undefined;
  } | null | undefined;
  readonly currentUser: {
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"RecordVideoButton_Video">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"user_isGuest">;
  } | null | undefined;
  readonly featuredFreelancers: ReadonlyArray<{
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"SampleVideosButton_SampleVideos">;
    } | null | undefined;
  }> | null | undefined;
};
export type RecordVideoButton_Query = {
  response: RecordVideoButton_Query$data;
  variables: RecordVideoButton_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Configuration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMinDuration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecordVideoButton_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecordVideoButton_Video"
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "user_isGuest",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "featuredFreelancers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SampleVideosButton_SampleVideos"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RecordVideoButton_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          (v1/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "featuredFreelancers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "optimizedUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "posterUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableSubtitles",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "d3486f617795e7207ea2095b8ddcf996",
    "id": null,
    "metadata": {},
    "name": "RecordVideoButton_Query",
    "operationKind": "query",
    "text": "query RecordVideoButton_Query {\n  currentUser {\n    video {\n      ...RecordVideoButton_Video\n      id\n    }\n    ...user_isGuest\n    id\n  }\n  featuredFreelancers {\n    video {\n      ...SampleVideosButton_SampleVideos\n      id\n    }\n    id\n  }\n  configuration {\n    videoMinDuration\n  }\n}\n\nfragment RecordVideoButton_Video on Video {\n  url\n}\n\nfragment SampleVideosButton_SampleVideos on Video {\n  id\n  ...Video_Video\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n"
  }
};
})();

(node as any).hash = "3a842fac8054bb58a72c74510a9c5db6";

export default node;
